import variables from './variables'

export default {
  colors: {
    buttons: {
      primaryBackground: variables.colors.skittlesBlue,
      secondaryText: variables.colors.skittlesBlue,
      secondaryOutline: variables.colors.skittlesBlue,
    },
  },
  anchorNavigation: {
    borderBottomStyle: 'none',
    borderBottomColor: 'none',
    borderBottomWidth: 'none',
    boxShadow: `0px 0px 10px ${variables.colors.gray300}`,
  },
}
